import Spacer from './Spacer';
export default Spacer;
//# sourceMappingURL=index.js.map